import { init, configureScope } from '@sentry/browser';

(function() {
  if (Cacoo.settings.sentryDSN !== undefined && Cacoo.settings.sentryDSN !== 'undefined' && Cacoo.settings.sentryDSN !== '') {
    const ua = require('./ua');
    init({
      dsn: Cacoo.settings.sentryDSN,
      release: Cacoo.settings.version,
    });
    configureScope(scope => {
      scope.setExtra('page_name', Cacoo.settings.pagename);
      scope.setTag('os.name', ua.osName);
      scope.setTag('browser', `${ua.browser} ${ua.browserVersion}`);
      scope.setTag('browser.name', ua.browser);
      scope.setTag('lang', Cacoo.settings.lang);
    });
  }
})();
